import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { HERO_APPLICATIONS, HeroApplication } from '../token';

@Injectable({ providedIn: 'root' })
export class HeroRedirectGuard implements CanActivate, CanActivateChild {
  private readonly router = inject(Router);
  private readonly applications = inject(HERO_APPLICATIONS) as HeroApplication[];

  private handle(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const defaultApp = this.applications.find(app => app.default);
    const to = route.data?.['to'] ?? defaultApp?.alias;

    if (!to) {
      console.error('No target or default application configured.');
      return false;
    }

    const target = this.applications.find(a => a.alias === to);
    if (!target?.route?.length) {
      console.error(`Application "${to}" not found or has no route.`);
      return false;
    }

    const targetPath = target.route.filter(Boolean).join('/');
    const currentPath = state.url.replace(/^\//, '');

    // Already at the target? Let it through to prevent redirect loops.
    if (currentPath === targetPath) return true;

    // Prefer returning a UrlTree over imperatively navigating
    return this.router.createUrlTree(target.route);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.handle(route, state);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.handle(route, state);
  }
}
